import React, { ReactElement } from 'react';

import { Box } from '@wds/box';
import { Responsive } from '@wds/responsive';
import { LogoWithText } from '@sm/webassets';
import { IconLogoGoldie } from '@wds/icons';

import useStyle from './useStyles';

export const GOLDIE_ICON = 'Logo__GoldieIcon';
export const GOLDIE_ICON_WITH_TEXT = 'Logo__GoldieIcon_with_text';

export default (): ReactElement => {
  const { seoBannerLogoLargeScreen, seoBannerLogoSmallScreen } = useStyle();

  return (
    <Box display="flex" flexDirection="column" flexAlign="center" flexJustify="center">
      <Responsive minWidth="xl">
        <div data-testid={GOLDIE_ICON_WITH_TEXT} className={seoBannerLogoLargeScreen}>
          <LogoWithText color="primary" />
        </div>
      </Responsive>
      <Responsive maxWidth="xl">
        <div data-testid={GOLDIE_ICON} className={seoBannerLogoSmallScreen}>
          <IconLogoGoldie title="" size="xl" color="primary" />
        </div>
      </Responsive>
    </Box>
  );
};
